<template>
  <div class="project pa-3">
    <div v-if="hasAccessToProjects">
      <v-row>
        <v-col>
          <bread-crumbs />
        </v-col>

        <v-col>
          <v-row>
            <v-col class="text-right pa-4">
              <v-btn
                v-if="showProjectDashboard && hasAccessToProjects"
                color="primary"
                @click="showFormProject"
              >
                Add Project
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-divider />
        </v-col>
      </v-row>

      <project-dashboard v-if="showProjectDashboard" />

      <project-profile v-if="showProjectProfile" />

      <project-modal />
    </div>

    <!--    <v-col v-else>-->
    <!--      <v-row>-->
    <!--        <v-col>-->
    <!--          &lt;!&ndash; Render a card indicating the view was not found. &ndash;&gt;-->
    <!--          <v-card-->
    <!--            class="mx-auto"-->
    <!--            max-width="400"-->
    <!--          >-->
    <!--            <v-card-title class="headline">-->
    <!--              View Not Found-->
    <!--            </v-card-title>-->

    <!--            <v-card-text>-->
    <!--              The view you are looking for does not exist.-->
    <!--            </v-card-text>-->
    <!--          </v-card>-->
    <!--        </v-col>-->
    <!--      </v-row>-->
    <!--    </v-col>-->
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import { makeProject } from '@/internal/store/utils/project'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')

export default {
  name: 'Project',

  components: {
    BreadCrumbs: () => import('@/layout/components/BreadCrumbs'),
    ProjectDashboard: () => import('../components/Projects'),
    ProjectModal: () => import('../components/ProjectModal'),
    ProjectProfile: () => import('../components/Project'),
  },

  computed: {
    ...mapAuthGetters([
      'hasAccessToProjects',
    ]),

    showProjectDashboard() {
      const { reportId } = this.$route.params

      return !reportId || reportId.length === 0 || reportId === 'dashboard'
    },

    showProjectProfile() {
      const { reportId } = this.$route.params
      return reportId && reportId.length > 0 && reportId !== 'dashboard'
    },
  },

  methods: {
    showFormProject() {
      const action = 'create'
      const formData = makeProject({})

      this.$store.dispatch('internal/showFormProject', { action, formData })
    },
  },
}
</script>
